var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { connect } from 'react-redux';
import { PANTALLA_ANTERIOR_ID, PANTALLA_VENTANA_ID } from '../constantes';
import * as actions from '../actions';
import { getPantallaProps, barraHerramientasSelectors, getConfigGeneral } from '../selectors';
import { getZona } from '../selectors/config-paginas';
import Ventana from './ventana';

var esFuncion = function esFuncion(boton) {
  return boton.vinculo.split(",")[0] === 'funcion';
};

var esGoto = function esGoto(boton) {
  return boton.vinculo.split(",")[0] === 'goto';
};

var PantallaVentana = connect(function (state, ownProps) {
  var pantallaProps = getPantallaProps(state);
  var libroId = ownProps.libroId || pantallaProps.libroId;
  var numPagina = ownProps.numPagina || pantallaProps.numPagina;
  var numZona = ownProps.numZona || pantallaProps.numZona;

  var zona = _extends({}, getZona(state, libroId, numPagina, numZona), ownProps.zona, pantallaProps.zona); // consola audio


  var textoTrack = getConfigGeneral(state).textoTrack; // herramientas

  var herramientasVisible = barraHerramientasSelectors.getVisible(state); // const relojVisible = relojSelectors.getVisible(state)
  // const relojConfig = relojSelectors.getConfig(state)

  return {
    libroId: libroId,
    numPagina: numPagina,
    numZona: numZona,
    zona: zona,
    herramientasVisible: herramientasVisible,
    // relojVisible,
    // relojConfig,
    // consola audio
    textoTrack: textoTrack
  };
}, function (dispatch, ownProps) {
  return {
    onAbrirZona: function onAbrirZona(libroId, numPagina, numZona) {
      dispatch(actions.pantalla(PANTALLA_VENTANA_ID, {
        libroId: libroId,
        numPagina: numPagina,
        numZona: numZona
      }));
    },
    onBoton: function onBoton(libroId, numPagina, numZona, boton) {
      /** cierra segunda ventana */
      dispatch(actions.pantalla(PANTALLA_VENTANA_ID, {
        boton: null
      }));
      /** interpretamos boton */

      if (esFuncion(boton)) {
        var funcion = boton.vinculo.split(",")[1];

        var _funcion$split = funcion.split(":"),
            nombre = _funcion$split[0],
            params = _funcion$split[1];

        if (nombre === "abrirIframe") {
          dispatch(actions.pantalla(PANTALLA_VENTANA_ID, {
            boton: boton
          }));
        } else {
          dispatch(actions.ejecutarFuncion(libroId, numPagina, numZona, nombre, params));
        }

        return;
      }

      if (esGoto(boton)) {
        var _boton$vinculo$split = boton.vinculo.split(","),
            LLPPP = _boton$vinculo$split[1],
            _numZona = _boton$vinculo$split[2];

        if (window.modoTrabajo) {
          window.console.info('goto-zona', boton);
        }

        dispatch(actions.ejecutarFuncion(libroId, numPagina, _numZona, 'abrirZona', LLPPP + '.' + _numZona));
        return;
      }

      dispatch(actions.pantalla(PANTALLA_VENTANA_ID, {
        boton: boton
      }));
    },
    onCerrar: function onCerrar() {
      /** cierra segunda ventana y zona */
      dispatch(actions.pantalla(PANTALLA_VENTANA_ID, {
        zona: {},
        boton: null
      }));
      /** pantalla anterior */

      dispatch(actions.pantalla(PANTALLA_ANTERIOR_ID));
    },
    onCerrarSegundaVentana: function onCerrarSegundaVentana() {
      return dispatch(actions.pantalla(PANTALLA_VENTANA_ID, {
        boton: null
      }));
    } // onCerrarReloj: () => dispatch(actions.ocultarReloj()),
    // onMoverReloj: (x, y) => dispatch(actions.moverReloj(x, y))

  };
})(Ventana);
export default PantallaVentana;